import { QuickfireCreditType, QuickfireFreeGamesModel } from "quickfire/model/quickfire-model";
import quickfireModel from "quickfire/model/quickfire-model";
import { asArray } from "slotworks/utils/collection-utils";

export function processFreeGames(response: QuickfireResponse) {

    if (response.FreeGames && response.FreeGames.Games && response.FreeGames.Games.FreeGame) {
        const allOffers = asArray(response.FreeGames.Games.FreeGame);

        for (const freeGame of allOffers) {

            const qfFreeGame = processFreeGame(response, freeGame);

            // Ensure free games in progress are at the start of the list
            if (qfFreeGame.gamesPlayed > 0) {
                quickfireModel.freeGames.unshift(qfFreeGame);
            } else {
                quickfireModel.freeGames.push(qfFreeGame);
            }
        }
    }

    // Sort in order of expiry date, but in progress games first
    quickfireModel.freeGames = quickfireModel.freeGames.sort((a, b) => a.unixEndTime < b.unixEndTime ? -1 : 1);
    quickfireModel.freeGames = quickfireModel.freeGames.sort((a, b) => a.gamesPlayed > 0 ? -1 : 1);

    // Check for finished game which was the last spin, so we can recovery summary / expiry message
    if (response.FreeGames && response.FreeGames.CurrentGame) {
        const qfCurrentFreeGame = response.FreeGames.CurrentGame;
        const currentFreeGame = {
            offerId: parseInt(qfCurrentFreeGame.attributes.offerId),
            instanceId: parseInt(qfCurrentFreeGame.attributes.instanceId),
            sumWinnings: parseInt(qfCurrentFreeGame.attributes.sumWinnings),
            gamesRemaining: parseInt(qfCurrentFreeGame.attributes.gamesRemaining),
            gamesPlayed: parseInt(qfCurrentFreeGame.attributes.gamesPlayed),
            unixEndTime: Infinity
        } as QuickfireFreeGamesModel;

        // If current game exists in freeGames array, then it is in play
        const gameIsCompleteOrExpired = !quickfireModel.freeGames.find((freeGame) => {
            return freeGame.offerId === currentFreeGame.offerId &&
                freeGame.instanceId === currentFreeGame.instanceId &&
                freeGame.sumWinnings === currentFreeGame.sumWinnings &&
                freeGame.gamesRemaining === currentFreeGame.gamesRemaining &&
                freeGame.gamesPlayed === currentFreeGame.gamesPlayed;
        });

        // Currenct free game is complete / expired
        if (gameIsCompleteOrExpired) {
            quickfireModel.freeGames.unshift(currentFreeGame);
        }
    }
}

function processFreeGame(response: QuickfireResponse, freeGame: QuickfireFreeGame) {

    const serverTime = new Date(response.FreeGames.Games.attributes.serverTime.replace(" ", "T")).getTime();
    const expireTime = new Date(freeGame.attributes.endDate.replace(" ", "T")).getTime();
    const unixEndTime = new Date().getTime() + expireTime - serverTime;

    return {
        offerId: parseInt(freeGame.attributes.offerId),
        instanceId: parseInt(freeGame.attributes.instanceId),
        sumWinnings: parseInt(freeGame.attributes.sumWinnings),
        gamesRemaining: parseInt(freeGame.attributes.gamesRemaining),
        gamesPlayed: parseInt(freeGame.attributes.gamesPlayed),
        gamesAwarded: parseInt(freeGame.attributes.gamesAwarded),
        endDate: freeGame.attributes.endDate,
        unixEndTime,
        creditType: freeGame.attributes.creditType === "0" ? QuickfireCreditType.CASH : QuickfireCreditType.BONUS,
        maxCost: parseInt(freeGame.attributes.maxCost),

        chipSize: parseInt(freeGame.DefaultBet.attributes.chipSize),
        numChips: parseInt(freeGame.DefaultBet.attributes.numChips),
        activePaylines: freeGame.DefaultBet.attributes.activePaylines.split(",").map((v) => parseInt(v))
    } as QuickfireFreeGamesModel;
}
